/* RAWNAQ × OMES — collection page behaviour. Theme asset: assets/rawnaq-plp.js (defer).
   Works on server-rendered cards: .pcard[data-cat][data-color][data-sizes][data-price][data-name][data-order].
   Category chips and sort select in the bar; "Filtrer" opens the panel (sort, category, colour swatches, sizes): bottom sheet on a phone, side drawer above 520px.
   Colours and sizes offered in the panel come from the loaded cards, so none leads to an empty grid.
   Wishlist in the theme's shared 'at_wishlist' store (header counter + /pages/wishlist), follow toggle.
   Achat rapide : [data-rq-add] ajoute la taille d'un clic ; [data-quickview] → sections/omes-quick-view.liquid (couleur à choisir, box). */
(function () {
  var root = document.querySelector('[data-rq-plp]');
  if (!root) return;
  var $ = function (s, el) { return (el || document).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); };
  var grid = $('[data-rq-grid]', root);
  var cards = $$('.pcard', grid);
  var sheet = $('[data-rq-sheet]');
  var state = { cat: 'all', color: 'all', sort: 'featured', sizes: {} };

  function list(c, key, sep) { var v = c.dataset[key]; return v ? v.split(sep) : []; }
  function buildFacets() {
    var colors = {}, sizes = {};
    cards.forEach(function (c) {
      list(c, 'color', ' ').forEach(function (k) { colors[k] = 1; });
      list(c, 'sizes', '|').forEach(function (k) { sizes[k] = 1; });
    });
    $$('.rq-sw[data-color]').forEach(function (b) { if (!colors[b.dataset.color]) b.remove(); });
    var colorSec = $('[data-rq-colors]');
    if (colorSec) colorSec.hidden = !$('.rq-sw', colorSec);
    var sizeSec = $('[data-rq-sizes]'), names = Object.keys(sizes).sort();
    if (sizeSec) {
      sizeSec.hidden = !names.length;
      names.forEach(function (z) {
        var b = document.createElement('button');
        b.className = 'rq-sz'; b.type = 'button'; b.textContent = z;
        b.setAttribute('data-size', z); b.setAttribute('aria-pressed', 'false');
        $('.rq-sh-sizes', sizeSec).appendChild(b);
      });
    }
  }

  function nSizes() { return Object.keys(state.sizes).filter(function (k) { return state.sizes[k]; }).length; }
  function hasFilter() { return state.cat !== 'all' || state.color !== 'all' || nSizes() > 0; }
  function apply() {
    var sorted = cards.slice();
    if (state.sort === 'price-asc') sorted.sort(function (a, b) { return a.dataset.price - b.dataset.price; });
    else if (state.sort === 'price-desc') sorted.sort(function (a, b) { return b.dataset.price - a.dataset.price; });
    else if (state.sort === 'name') sorted.sort(function (a, b) { return a.dataset.name.localeCompare(b.dataset.name, 'fr'); });
    else sorted.sort(function (a, b) { return a.dataset.order - b.dataset.order; });
    var picked = Object.keys(state.sizes).filter(function (k) { return state.sizes[k]; });
    var n = 0;
    sorted.forEach(function (c) {
      var sz = list(c, 'sizes', '|');
      var ok = (state.cat === 'all' || c.dataset.cat === state.cat)
        && (state.color === 'all' || list(c, 'color', ' ').indexOf(state.color) > -1)
        && (!picked.length || picked.some(function (s) { return sz.indexOf(s) > -1; }));
      c.hidden = !ok; if (ok) n++;
      grid.appendChild(c);
    });
    $$('[data-cat]').forEach(function (b) { var on = b.dataset.cat === state.cat; b.classList.toggle('active', on); b.setAttribute('aria-pressed', on); });
    $$('[data-sort]').forEach(function (b) { b.classList.toggle('on', b.dataset.sort === state.sort); });
    $$('.rq-sw[data-color]').forEach(function (b) { var on = b.dataset.color === state.color; b.classList.toggle('on', on); b.setAttribute('aria-pressed', on); });
    $$('[data-size]').forEach(function (b) { var on = !!state.sizes[b.dataset.size]; b.classList.toggle('on', on); b.setAttribute('aria-pressed', on); });
    var ss = $('[data-rq-sort]', root); if (ss) ss.value = state.sort;
    var dot = $('[data-rq-dot]', root); if (dot) dot.hidden = !hasFilter();
    var em = $('[data-rq-empty]', root); if (em) em.hidden = n > 0;
    var go = $('[data-rq-go]'); if (go) go.textContent = n ? 'Afficher ' + n + ' article' + (n > 1 ? 's' : '') : 'Aucun résultat';
  }
  function clear() { state.cat = 'all'; state.color = 'all'; state.sizes = {}; apply(); }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cat]:not(.pcard),[data-sort],.rq-sw[data-color],[data-size],[data-rq-clear-all],[data-rq-reset],[data-rq-open],[data-rq-close]');
    if (!t || !(root.contains(t) || (sheet && sheet.contains(t)))) return;
    if (t.hasAttribute('data-cat')) state.cat = t.dataset.cat;
    else if (t.hasAttribute('data-sort')) state.sort = t.dataset.sort;
    else if (t.hasAttribute('data-color')) state.color = state.color === t.dataset.color ? 'all' : t.dataset.color;
    else if (t.hasAttribute('data-size')) state.sizes[t.dataset.size] = !state.sizes[t.dataset.size];
    else if (t.hasAttribute('data-rq-reset')) { state.sort = 'featured'; clear(); return; }
    else if (t.hasAttribute('data-rq-clear-all')) { clear(); return; }
    else if (t.hasAttribute('data-rq-open')) { openSheet(true); return; }
    else if (t.hasAttribute('data-rq-close')) { openSheet(false); return; }
    apply();
  });
  var ss = $('[data-rq-sort]', root); if (ss) ss.addEventListener('change', function () { state.sort = ss.value; apply(); });

  var lastFocus = null;
  function openSheet(on) {
    if (!sheet) return;
    sheet.classList.toggle('open', on); sheet.setAttribute('aria-hidden', !on);
    document.documentElement.style.overflow = on ? 'hidden' : '';
    if (on) { lastFocus = document.activeElement; var x = $('.rq-sh-x', sheet); if (x) setTimeout(function () { x.focus(); }, 60); }
    else if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sheet && sheet.classList.contains('open')) openSheet(false); });

  /* Après un ajout depuis l'aperçu rapide : le compteur panier de l'en-tête
     (#cart-icon-bubble) est rendu côté serveur et l'aperçu ne le met pas à
     jour — on le rafraîchit, et on confirme par un toast. */
  var toast = $('[data-rq-toast]'), tt;
  function showToast(msg, isErr) {
    if (!toast) return;
    var s = toast.querySelector('span'); if (s) s.textContent = msg;
    toast.classList.toggle('err', !!isErr); toast.classList.add('on');
    clearTimeout(tt); tt = setTimeout(function () { toast.classList.remove('on'); }, 1900);
  }
  document.addEventListener('cart:updated', function () {
    showToast('Ajouté au panier');
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(base + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { $$('#cart-icon-bubble').forEach(function (b) { b.textContent = c.item_count; }); })
      .catch(function () {});
  });

  /* Achat rapide : même appel que l'aperçu rapide (sections/omes-quick-view.liquid),
     pour que le tiroir panier, les compteurs et le suivi réagissent pareil. */
  function quickAdd(btn) {
    var id = Number(btn.dataset.rqAdd);
    var cart = document.querySelector('cart-drawer');
    var body = { id: id, quantity: 1 };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message); return j; }); })
      .then(function (item) {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item: item } }));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'rawnaq-quick-add', productVariantId: id, cartData: item });
        if (cart && item.sections && typeof cart.renderContents === 'function') { cart.classList.remove('is-empty'); cart.renderContents(item); }
      })
      .catch(function (err) { showToast(err.message || "Impossible d'ajouter cet article", true); })
      .finally(function () { btn.disabled = false; });
  }

  /* Favoris : même stockage que le reste du thème ('at_wishlist', tableau
     d'IDs produit en chaîne) pour que le compteur de l'en-tête et la page
     Favoris suivent. */
  var WL = 'at_wishlist';
  function wlGet() { try { var v = JSON.parse(localStorage.getItem(WL) || '[]'); return Array.isArray(v) ? v.map(String) : []; } catch (e) { return []; } }
  function wlHeader(ids) {
    if (window.checkWishlist) { try { window.checkWishlist(); return; } catch (e) {} }
    var c = document.querySelector('#wishlistItems'); if (c) c.innerHTML = ids.length;
  }
  function paintWish() {
    var ids = wlGet();
    $$('.pcard .fav', grid).forEach(function (fav) {
      var on = ids.indexOf(String(fav.dataset.id)) > -1;
      fav.classList.toggle('on', on); fav.setAttribute('aria-pressed', on);
      fav.setAttribute('aria-label', on ? 'Retirer des favoris' : 'Ajouter aux favoris');
    });
  }
  grid.addEventListener('click', function (e) {
    var add = e.target.closest('[data-rq-add]');
    if (add) { e.preventDefault(); quickAdd(add); return; }
    var fav = e.target.closest('.fav'); if (!fav) return;
    e.preventDefault(); e.stopPropagation();
    var id = String(fav.dataset.id), ids = wlGet(), i = ids.indexOf(id);
    if (i > -1) ids.splice(i, 1); else ids.unshift(id);
    try { localStorage.setItem(WL, JSON.stringify(ids)); } catch (err) {}
    paintWish(); wlHeader(ids);
  });
  window.addEventListener('storage', function (e) { if (e.key === WL) paintWish(); });
  paintWish();


  buildFacets();
  apply();
})();
